<template>
  <div>
    <el-dialog :title="$t('message.temporaryRemarks')" :close-on-click-modal="false"
      :visible.sync="$parent.temporaryRemarksDialogVisible" width="400px" center>
      <div class="textarea">
        <el-input type="textarea" v-model="remark" show-word-limit resize="none" onfocus="this.select()">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$parent.temporaryRemarksDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="updateTempRemark">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    list: { type: Array },
  },
  data() {
    return {
      remark: "",
    };
  },
  methods: {
    updateTempRemark() {
      let datas = {
        problem_goods_id: '',
        remark: this.remark,
      };
      console.log(this.list);
      this.list.forEach(item => {
        datas.problem_goods_id = item.problem_goods_id
        this.$api.problemApi.updateTempRemark(datas).then((res) => {
          this.$message.success(res.msg)
          this.$parent.temporaryRemarksDialogVisible = false;
          // 临时保存进去
          this.$parent.problemList();
        });
        // this.$parent.list.forEach(item => {
        //   item.groupByPurchaseNo.forEach(PurchaseNo => {
        //     PurchaseNo.list.forEach(items => {
        //       if (items.problem_goods_id == datas.problem_goods_id) {
        //         items.y_deal = this.remark
        //         this.$forceUpdate
        //       }
        //     })
        //   })
        // })
      })


    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-textarea__inner {
  height: 100px;
}
</style>